(function(){
var el=document.querySelector('[data-vxpeso]');if(!el)return;
var P={};try{P=JSON.parse(el.textContent)}catch(e){return}
function fmt(n){return n.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2})}
function fmtq(n){var s=n.toLocaleString('pt-BR',{minimumFractionDigits:0,maximumFractionDigits:3});return s}
function idAtual(){
 var u=new URLSearchParams(location.search).get('variant');
 if(u&&P[u])return u;
 var i=document.querySelector('input[name="id"],select[name="id"]');
 if(i&&P[i.value])return i.value;
 var k=Object.keys(P);return k.length?k[0]:null}
function pinta(){
 var id=idAtual();if(!id)return;
 var d=P[id];if(!d)return;
 var box=document.querySelector('[data-vxpeso-box]'),lin=document.querySelector('[data-vxpeso-total]');
 if(!d.kg||d.por!=='kg'){if(box)box.hidden=true;if(lin)lin.hidden=true;return}
 var q=1,inp=document.querySelector('.quantity__input,input[name="quantity"]');
 if(inp)q=parseFloat(inp.value)||1;
 var tot=q*d.kg, val=d.pkg||0;
 if(box){
  box.hidden=false;
  box.innerHTML='<span class="vxpeso__un">R$ '+fmt(val)+' <em>por kg</em></span>'+
   '<span class="vxpeso__emb">'+d.emb+' de '+fmtq(d.kg)+' kg</span>'}
 if(lin){
  lin.hidden=false;
  lin.innerHTML='<span class="vxpeso__rot">Quantidade</span>'+
   '<span class="vxpeso__calc"><b>'+q+'</b> '+(q===1?d.emb.toLowerCase():d.emb.toLowerCase()+'s')+
   ' &times; '+fmtq(d.kg)+' kg = <b>'+fmtq(tot)+' kg</b></span>'}
 var lbl=document.querySelector('.quantity__label,label[for^="Quantity"]');
 if(lbl)lbl.textContent='Quantidade em '+d.emb.toLowerCase()+(q===1?'':'s');
}
function amarra(){
 var inp=document.querySelector('.quantity__input,input[name="quantity"]');
 if(inp&&!inp.dataset.vxpeso){inp.dataset.vxpeso='1';
  inp.addEventListener('input',pinta);inp.addEventListener('change',pinta)}
 var f=document.querySelector('form[action*="/cart/add"]');
 if(f&&!f.dataset.vxpeso){f.dataset.vxpeso='1';
  f.addEventListener('submit',function(){
   var id=idAtual();if(!id)return;var d=P[id];if(!d||!d.kg||d.por!=='kg')return;
   var q=parseFloat((document.querySelector('.quantity__input,input[name="quantity"]')||{value:1}).value)||1;
   ['Peso total','Embalagem','Valor do kg'].forEach(function(k,i){
    var v=[fmtq(q*d.kg)+' kg', d.emb+' de '+fmtq(d.kg)+' kg', 'R$ '+fmt(d.pkg||0)][i];
    var h=f.querySelector('input[name="properties['+k+']"]');
    if(!h){h=document.createElement('input');h.type='hidden';h.name='properties['+k+']';f.appendChild(h)}
    h.value=v})})}
}
pinta();amarra();
document.addEventListener('change',function(e){if(e.target.closest('variant-selects,variant-radios,.product-form__input')){setTimeout(function(){pinta();amarra()},60)}});
new MutationObserver(function(){pinta();amarra()}).observe(document.body,{subtree:true,childList:true});
})();
